'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPublishFailed = undefined;

var _isStatus = require('./isStatus');

var _messageStatusTypes = require('../constants/messageStatusTypes');

var _statusTypes = require('../../common-message-format/constants/statusTypes');

var isPublishFailed = exports.isPublishFailed = function isPublishFailed(message) {
  return (0, _isStatus.isStatus)(_messageStatusTypes.PUBLISH_FAILED, message) || (0, _isStatus.isStatus)(_statusTypes.FAILED, message);
};